import {createAction} from '@reduxjs/toolkit'

import {isFirefox} from '@web/helpers/userAgent'

import {
    HistoryChangeType,
    LocationChangeType,
    ScrollToActionType,
    SystemAlertType,
    SystemConfirmType,
} from './interfaces'

export {LocationChangeAction, HistoryChangeAction, AlertAction, ConfirmAction} from './constants'

/** 스크롤이동 action */
export const scrollTo = createAction<ScrollToActionType>('application/scrollToAction')

/** location change action */
export const changeLocation = createAction('application/changeLocation', (payload: LocationChangeType) => {
    /**
     * see https://oss.fin.navercorp.com/Product-Planning/PG_Dicon-Npay_Plan/issues/577
     * 주문형 이슈로 인해 alert 딜레이 된 경우 alert + changeLocation 발생시 locationChange가 먼저 일어나 alert이 제대로 노출되지 않는 이슈 대응.
     * delay는 브라우저 이슈가 있는 환경에서만 발동한다. 항시 사용가능 할 시 로직간의 tick schedule이 꼬일 수 있음.
     */
    return {
        payload: {
            ...payload,
            delay: isFirefox && payload.browserDependentDelay,
        },
    }
})

/** history change action */
export const historyChange = createAction<HistoryChangeType>('application/historyChange')

/** system alert action */
export const systemAlert = createAction(
    'application/systemAlert',
    ({type, message, browserDependentDelay}: SystemAlertType) => {
        return {
            payload: {
                type,
                message,
                delay: isFirefox && browserDependentDelay,
            },
        }
    },
)

export const openNewWindow = createAction('openNewWindow', (url: string) => {
    return {payload: url}
})

/** system confirm action */
export const systemConfirm = createAction<SystemConfirmType>('application/systemConfirm')

/** app unload action */
export const appUnload = createAction('app/unload')

export type ThunkApi<RejectValue> = {
    state: unknown
    rejectValue: RejectValue
}
